<template>
  <!-- name: '团队合作' -->
  <div class="teamworkWrap">
    <div class="topBox">
      <div class="headerBox">
        <img src="https://img.bbalt.cn/imgh5/teamwork/logo.png" alt="" class="logoClass" />
        <img
          src="https://img.bbalt.cn/imgh5/icon_fork.png"
          alt=""
          class="forkClass"
        />团体合作
      </div>
      <div class="cardBox">
        <div class="cardClass">
          <img src="https://img.bbalt.cn/imgh5/teamwork/img_card1.png" alt="" />
          <div class="textClass bg1">
            <span>资助</span>
            <span>运营费用</span>
          </div>
        </div>
        <div class="cardClass">
          <img src="https://img.bbalt.cn/imgh5/teamwork/img_card2.png" alt="" />

          <div class="textClass bg2">
            <span>一起</span>
            <span>捐衣/捐物</span>
          </div>
        </div>
        <div class="cardClass">
          <img src="https://img.bbalt.cn/imgh5/teamwork/img_card3.png" alt="" />
          <div class="textClass bg3">
            <span>一起</span>
            <span>手作活动</span>
          </div>
        </div>
        <div class="cardsBox">
          <div class="textClass" @click="$toast.fail('暂时不开放此功能');">
            <span>我的</span>
            <span>团体合作</span>
          </div>
          <div class="textClass" @click="$toast.fail('暂时不开放此功能');">
            <span>其他</span>
            <span>合作方式</span>
          </div>
        </div>
      </div>
    </div>
    <img src="https://img.bbalt.cn/imgh5/teamwork/bg_btn.png" alt="" class="btnImgClass" @click="$router.push({
            path: '/becomePartner'
          })"/>
    <div class="titleBox">
      <span class="heartClass"></span>
      <span class="textClass">合作案例分享</span>
      <span class="heartClass"></span>
    </div>
    <div class="imgBox">
      <img src="https://img.bbalt.cn/imgh5/banner/3.png" alt="" @click="$router.push({path: '/cmsIndex', query: {code: 'becomePartnerShareCase'}})"/>
    </div>
    <div class="titleBox" style="display: none;">
      <span class="heartClass"></span>
      <span class="textClass">感谢以下合作伙伴对我们的支持</span>
      <span class="heartClass"></span>
    </div>
    <div class="logoBox" style="display: none;">
      <img src="https://img.bbalt.cn/imgh5/teamwork/project_logo_1.png" alt="" />
      <img src="https://img.bbalt.cn/imgh5/teamwork/project_logo_2.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.teamworkWrap {
  height: calc(100% - 100px);
  width: 100%;
  background: #fff;
  text-align: center;
  overflow: auto;
  padding-bottom: 37px;
  display: flex;
  align-items: center;
  flex-flow: column;
  font-family: PingFang-SC, PingFang-SC;
  .topBox {
    background-image: url("https://img.bbalt.cn/imgh5/teamwork/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 560px;
    .headerBox {
      margin-top: 58px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      font-size: 36px;
      font-weight: bold;
      color: #333333;
      line-height: 50px;
      .logoClass {
        width: 93px;
        height: 50px;
        margin-right: 15px;
      }
      .forkClass {
        width: 26px;
        height: 26px;
        margin-right: 13px;
      }
    }
    .cardBox {
      margin: 48px 32px 12px 32px;
      display: flex;

      justify-content: space-between;
      .cardClass {
        width: 160px;
        height: 296px;
        border-radius: 50%;
        position: relative;
        color: #fff;
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          bottom: 0px;
          left: 0px;
        }
        .textClass {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 96px;
          border-radius: 0px 0px 8px 8px;
          padding-left: 16px;
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: flex-start;
          span {
            font-size: 22px;
            font-weight: 400;
            opacity: 0.8;
            &:last-child {
              font-size: 28px;
              margin-top: 5px;
              opacity: 1;
            }
          }
        }

        .bg1 {
          background: rgba(254, 102, 166, 0.9);
        }
        .bg2 {
          background: rgba(175, 200, 117, 0.9);
        }
        .bg3 {
          background: rgba(60, 69, 105, 0.9);
        }
      }
      .cardsBox {
        width: 160px;
        height: 296px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        .textClass {
          width: 160px;
          height: 140px;
          background: #ffffff;
          border-radius: 8px;
          border: 1px solid #dddddd;
          background-image: url("https://img.bbalt.cn/imgh5/teamwork/bg_team.svg");
          background-repeat: no-repeat;
          background-size: 113px 138px;
          background-position: 42px 9px;
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: flex-start;
          padding-left: 24px;
          span {
            font-size: 22px;
            font-weight: 400;
            color: #666666;
            &:last-child {
              font-size: 28px;
              font-weight: 600;
              color: #333333;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
  .btnImgClass {
    margin-left: 42px;
    height: 160px;
    width: 614px;
  }
  .titleBox {
    height: 46px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 29px;
    margin-bottom: 32px;
    .heartClass {
      position: relative;
      top: 12px;
      width: 12px;
      height: 12px;
      background-color: #333;
      transform: rotate(-135deg);
      margin-top: -24px;
      &::before {
        content: "";
        position: absolute;
        top: 6px;
        left: 0px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #333;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0px;
        left: 6px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #333;
      }
    }
    .textClass {
      font-size: 36px;
      font-weight: bold;
      color: #333333;
      margin: 0px 32px;
    }
  }
  .imgBox {
    width: 686px;
    margin-bottom: 35px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  }
  .logoBox {
    width: 100%;
    padding: 0px 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    img {
      &:nth-child(1) {
        width: 200px;
        object-fit: cover;
        margin-right: 70px;
      }
      &:nth-child(2) {
        width: 60px;
        object-fit: cover;
      }
    }
  }
}
</style>
